/* eslint-disable react/prop-types */
import React from 'react';
import Spinner from './Spinner';

interface Props {
  loading: boolean;
  children?: React.ReactNode;
}

const SpinnerArea: React.FC<Props> = ({ loading = false, children }) => (
  <>
    <Spinner loading={loading} />
    <div className={loading ? 'spinner-area' : ''}>{children}</div>
  </>
);

export default SpinnerArea;
